import React from "react";

const PlansAndPricingHeroSection = ()=>{
    return(
        <>
        <div class="common-hero">
          <div class="container">
            <div class="row align-items-center text-center">
              <div class="col-lg-6 m-auto">
                <div class="main-heading">
                  <h1>Plans & Pricing</h1>
                    <div class="space16"></div>
                    <span class="span"><img src="/assets/img/icons/span1.png" alt=""/> <a href="index.html">Home</a> <span class="arrow"><i class="fa-solid fa-angle-right"></i></span> Plans & Pricing</span>
                </div>
              </div>

            </div>
          </div>
        </div>
        </>
    )
}

export default PlansAndPricingHeroSection;